import { SET_REQUEST_STATUS } from './types';
import { RequestStatus } from '../../models/RequestStatus';

export function setRequestStatus(status: RequestStatus) {
  return {
    type: SET_REQUEST_STATUS,
    payload: status,
  };
}
